'use strict';

var base = require('providiobase/product/base');

function pdpImagesSlick() {
    var $pdpSlick = $(document).find('.product-image-carousel');
    var $pdpSlickOptions = {
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        focusOnSelect: true,
        infinite: true,
        dots: false,
        draggable: true,
        asNavFor: '.product-thumbnail-slick'
    };

    var $slidesToShowValue = 5;
    var $slidesToScrollValue = 1;

    // $childElements is calculated before initializing slick, based on the number of child elements $slidesToShowValue and $slidesToScrollValue is updated and then slick is initialized. */
    var $childElements = $('.product-thumbnail-slick').children().length;
    if ($slidesToShowValue >= $childElements) {
        $slidesToShowValue = $childElements;
        $slidesToScrollValue = $childElements;
    }

    // Initializing thumbnail slick and product images slick in PLP page */
    var $thumbnailSlick = $(document).find('.product-thumbnail-slick');
    var $tumbnailSlickOptions = {
        asNavFor: '.product-image-carousel',
        slidesToShow: $slidesToShowValue,
        slidesToScroll: $slidesToScrollValue,
        dots: false,
        centerMode: false,
        focusOnSelect: true,
        arrows: true,
        vertical: true,
        infinite: false,
        verticalSwiping: true,
        draggable: true,
        prevArrow: '<div class="slick-prev "><span class="fa fa-angle-up"></span><span class="sr-only">Prev</span></div>',
        nextArrow: '<div class="slick-next "><span class="fa fa-angle-down"></span><span class="sr-only">Next</span></div>'
    };

    $pdpSlick.on('afterChange', function (event, slick, currentSlide) {
        console.log(currentSlide)
        $thumbnailSlick.slick('slickGoTo', currentSlide);
        $thumbnailSlick.find('.slick-slide.slick-current').removeClass('slick-current');
        $thumbnailSlick.find('.slick-slide[data-slick-index="' + currentSlide + '"]').addClass('slick-current');
    });

    if (!$thumbnailSlick.hasClass('slick-initialized')) {
        $thumbnailSlick.slick($tumbnailSlickOptions);
    }

    if (!$pdpSlick.hasClass('slick-initialized')) {
        $pdpSlick.slick($pdpSlickOptions);
    }
}

module.exports = $.extend({}, base, {
    pdpImagesSlick: pdpImagesSlick
});
